<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="
      cn(
        'icon icon-tabler icons-tabler-outline icon-tabler-sparkles size-4',
        props.class
      )
    "
  >
    <defs>
      <linearGradient id="sparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#22c55e" />
        <stop offset="25%" stop-color="#06b6d4" />
        <stop offset="30%" stop-color="#3b82f6" />
        <stop offset="70%" stop-color="#a855f7" />
        <stop offset="75%" stop-color="#ec4899" />
        <stop offset="80%" stop-color="#f97316" />
        <stop offset="100%" stop-color="#22c55e" />
      </linearGradient>
    </defs>

    <path stroke="none" d="M0 0h24v24H0z" fill="none" />

    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path
      stroke="url(#sparkleGradient)"
      d="M13 7a9.3 9.3 0 0 0 1.516 -.546c.911 -.438 1.494 -1.015 1.937 -1.932c.207 -.428 .382 -.928 .547 -1.522c.165 .595 .34 1.095 .547 1.521c.443 .918 1.026 1.495 1.937 1.933c.426 .205 .925 .38 1.516 .546a9.3 9.3 0 0 0 -1.516 .547c-.911 .438 -1.494 1.015 -1.937 1.932a9 9 0 0 0 -.547 1.521c-.165 -.594 -.34 -1.095 -.547 -1.521c-.443 -.918 -1.026 -1.494 -1.937 -1.932a9 9 0 0 0 -1.516 -.547"
    />
    <path
      stroke="url(#sparkleGradient)"
      d="M3 14a21 21 0 0 0 1.652 -.532c2.542 -.953 3.853 -2.238 4.816 -4.806a20 20 0 0 0 .532 -1.662a20 20 0 0 0 .532 1.662c.963 2.567 2.275 3.853 4.816 4.806q .75 .28 1.652 .532a21 21 0 0 0 -1.652 .532c-2.542 .953 -3.854 2.238 -4.816 4.806a20 20 0 0 0 -.532 1.662a20 20 0 0 0 -.532 -1.662c-.963 -2.568 -2.275 -3.853 -4.816 -4.806a21 21 0 0 0 -1.652 -.532"
    />
  </svg>
</template>
